import { Component, EventEmitter, OnInit, Input, Output, ViewChild, forwardRef } from '@angular/core';
import { EmailValidator, FormBuilder, FormGroup, Validators, FormArray } from '@angular/forms';
import {Message, OverlayPanel, SelectItem} from 'primeng/primeng';

//constants

//validators
import { dropDownValidator }                from '../../validators/CustomValidators';
import { hiddenDropDownValueValidator }                from '../../validators/CustomValidators';

import * as ent from '../../entities/index'
import * as enums from '../../enums/index'
import * as filters from '../../filters/index'

//components
import {VendorLineItemGridComponent} from '../../components/Grids/VendorLineItemGrid.component';
import {ModelGroupDropdownComponent} from '../../components/DomainData/ModelGroupDropdown.component';
import {SpecificModelReasonDropdownComponent} from '../../components/DomainData/SpecificModelReasonDropdown.component';
import {ModelDropdownComponent} from '../../components/DomainData/ModelDropdown.component';
import {EquipmentGraphicsDropdownComponent} from '../../components/DomainData/EquipmentGraphicsDropdown.component';
import {SecurityLevelDropdownComponent} from '../../components/DomainData/SecurityLevelDropdown.component';
import {CardReaderDropdownComponent} from '../../components/DomainData/CardReaderDropdown.component';

//constants
import { Constants }         from '../../constants/Constants';

//base
import { BaseControlGroupComponent }         from '../../baseclasses/BaseControlGroup.component';
import { EquipmentLocationsComponent } from './EquipmentLocations.component';

@Component({
  selector: 'my-vendordetails',
  templateUrl: './VendorDetails.component.html',
  providers: [{provide: BaseControlGroupComponent, useExisting: forwardRef(() => VendorDetailsComponent)}]
})
export class VendorDetailsComponent extends BaseControlGroupComponent {

    modelGroupFilter: filters.ModelGroupFilter;
    modelFilter: filters.ModelFilter;
    removeReasonFilter: filters.ActivityReasonFilter;
    installReasonFilter: filters.ActivityReasonFilter;

    @Input() public showNumberOfVendors: boolean;
    @Input() public maxLineItemCount: number;

    @ViewChild(VendorLineItemGridComponent) public vendorLineItemGrid: VendorLineItemGridComponent;
    @ViewChild(ModelGroupDropdownComponent) public modelGroupDropdownComponent: ModelGroupDropdownComponent;
    @ViewChild(SpecificModelReasonDropdownComponent) public specificModelReasonDropdownComponent: SpecificModelReasonDropdownComponent;
    @ViewChild(ModelDropdownComponent) public modelDropdownComponent: ModelDropdownComponent;
    @ViewChild(EquipmentGraphicsDropdownComponent) public equipmentGraphicsDropdownComponent: EquipmentGraphicsDropdownComponent;
    @ViewChild(SecurityLevelDropdownComponent) public securityLevelDropdownComponent: SecurityLevelDropdownComponent;
    @ViewChild(CardReaderDropdownComponent) public cardReaderDropdownComponent: CardReaderDropdownComponent;
    @ViewChild(EquipmentLocationsComponent) public equipmentLocationsComponent: EquipmentLocationsComponent;
  
    vendorInfo: ent.VendorInfo = new ent.VendorInfo();
  
    vendorDetailsForm: FormGroup;

    

    @Input() public requestTypeID: number;
    @Input() public showVendorGrid: boolean = true;
    @Input() public showModelGroup: boolean = true;
    @Input() public showModel: boolean = true;
    @Input() public showEquipmentGraphics: boolean = true;
    @Input() public showSecurityLevel: boolean = true;
    @Input() public showSecurityCage: boolean = true;
    @Input() public showCardReader: boolean = true;
    @Input() public showDefaultModel: boolean = true;
    @Input() public showMaterialNumber: boolean = true;
    @Input() public showCONAModelGroup: boolean = true;
    @Input() public showSetOnSite: boolean = true;
    @Input() public showCasters: boolean = true;
    @Input() public showRemoveReason: boolean;
    @Input() public showInstallReason: boolean;
    @Input() public showSpecificModelNeeded: boolean;
    @Input() public showSpecificModelReason: boolean;
    @Input() public showProjectedVolume: boolean;
    @Input() public showEquipmentLocations: boolean;
    @Input() public showEquipmentLocationOnGrid: boolean;
    
    @Input() public requireModelGroup: boolean;
    @Input() public requireSpecificModelNeeded: boolean;
    @Input() public requireSpecificModelReason: boolean;
    @Input() public requireModel: boolean;
    @Input() public requireEquipmentGraphics: boolean;
    @Input() public requireEquipmentLocation: boolean;
    @Input() public requireNumberOfVendors: boolean;
    @Input() public requireProjectedVolume: boolean;

    setDates(){}

    setRequestInfo(request: ent.Request) {
        this.vendorInfo = request.VendorInfo;
        if (this.vendorLineItemGrid){
            this.vendorLineItemGrid.lineItems = request.VendorLineItems;
        }
        
        this.equipmentLocationsComponent.setEquipmentLocations(this.vendorInfo.EquipmentLocations);
    }

    constructor(fb: FormBuilder) 
    { 
        super();
        this.removeReasonFilter = {RequestTypeID: this.requestTypeID, EquipmentClassID: enums.EquipmentClassEnum.Vendor, EquipmentActivityID: enums.EquipmentActivityEnum.Remove};
        this.installReasonFilter = {RequestTypeID: this.requestTypeID, EquipmentClassID: enums.EquipmentClassEnum.Vendor, EquipmentActivityID: enums.EquipmentActivityEnum.Install};

        let group = {
            'removeReason' : '',
            'installReason' : '',
            'modelGroup' : '',
            'specificModelNeeded' : '',
            'specificModelReason' : '',
            'model' : '',
            'equipmentGraphics' : '',
            'securityLevel' : '',
            'securityCage' : '',
            'cardReader' : '',
            'equipmentLocation' : '',
            'numberOfVendors' : '',
            'defaultModel' : {value:'', disabled: "true"},
            'materialNumber' : {value:'', disabled: "true"},
            'conaModelGroup' : {value:'', disabled: "true"},
            'setOnSite' : '',
            'casters' : '',
            'levelSellDown' : '',
            'projectedVolume' : ''
        };
        
        this.vendorDetailsForm = fb.group(group);

    }

    ngOnInit(): void {
        
        
        if(this.requireModelGroup) {
            this.vendorDetailsForm.controls['modelGroup'].setValidators(Validators.required);
        }

        if(this.requireSpecificModelNeeded) {
          this.vendorDetailsForm.controls['specificModelNeeded'].setValidators(Validators.required);
        }

        if(this.requireSpecificModelReason) {
          this.vendorDetailsForm.controls['specificModelReason'].setValidators(Validators.required);
        }

        if(this.requireModel) {
          this.vendorDetailsForm.controls['model'].setValidators(Validators.required);
        }

        if(this.requireEquipmentGraphics) {
          this.vendorDetailsForm.controls['equipmentGraphics'].setValidators(Validators.required);
        }

        if(this.requireEquipmentLocation) {
          this.vendorDetailsForm.controls['equipmentLocation'].setValidators(Validators.required);
        }

        if(this.requireNumberOfVendors) {
          this.vendorDetailsForm.controls['numberOfVendors'].setValidators(Validators.required);
        }
        if(this.requireProjectedVolume) {
            this.vendorDetailsForm.controls['projectedVolume'].setValidators(Validators.required);
        }

        
    }

    public ngAfterViewInit() {
        this.load();
    }

    public load(){
        
        this.modelGroupFilter = {SectionID: enums.Section.VendorInfo};

        if (this.modelGroupDropdownComponent) {
            this.modelGroupDropdownComponent.filter = this.modelGroupFilter;
            this.modelGroupDropdownComponent.loadOnDemand();
        }
        if (this.modelDropdownComponent) {
            this.modelFilter = {SectionID: enums.Section.VendorInfo};
        
            this.modelDropdownComponent.filter = this.modelFilter;
            this.modelDropdownComponent.loadOnDemand();
        }
    }

    getEquipmentLocationsInfoText() : string {
        if (this.requestTypeID == enums.RequestTypeEnum.FullServiceCustomer){
            return "Enter one Equipment Location for each Vendor that needs to be installed. Example: 5 Locations will result in 5 FSV Customers being created, each having a Vendor installed with the specified products, machine type, and location";
        }
        else {
            return "Enter one Equipment Location for each Vendor that needs to be installed or swapped";
        }
    }

    removeReasonChange(event: any){
        this.vendorInfo.RemoveReasonID = event;
    }

    installReasonChange(event: any){
        this.vendorInfo.InstallReasonID = event;
    }
    
    modelGroupChange(event: any){
        this.vendorInfo.ModelGroupID = event;
        if (event){
            this.modelDropdownComponent.filter.ModelGroupID = event;
            this.modelDropdownComponent.loadOnDemand();
        }
        this.setDefaultModel();
    }

    specificModelReasonChange(event: any){
        this.vendorInfo.SpecificModelReasonID = event;
    }

    modelChange(event: any){
        this.vendorInfo.ModelID = event;

        if (this.vendorInfo.ModelGroupID > 0){
            this.vendorInfo.MaterialNumber = this.modelDropdownComponent.models.filter(x=>x.ID == this.vendorInfo.ModelID)[0].MaterialNumber;
        }

        var model = this.modelDropdownComponent.models.filter(x=>x.ID == this.vendorInfo.ModelID)[0];
        this.equipmentGraphicsDropdownComponent.filter.EquipmentGraphicsIDs = [];
        if (model){
            if (model.EquipmentGraphics){
                for (var eg of model.EquipmentGraphics){
                    this.equipmentGraphicsDropdownComponent.filter.EquipmentGraphicsIDs.push(eg.ID);
                }
            }
        }
        this.equipmentGraphicsDropdownComponent.loadOnDemand();
        
        this.setMaterialNumber();
        this.setCONAModelNumber();
    }

    equipmentGraphicsChange(event: any){
        this.vendorInfo.EquipmentGraphicsID = event;
    }

    securityLevelChange(event: any){
        this.vendorInfo.SecurityLevelID = event;
    }

    cardReaderChange(event: any){
        this.vendorInfo.CardReaderID = event;
    }

    specificModelNeededChange(event: any){
        this.vendorInfo.ModelGroupID = this.modelGroupDropdownComponent.value;
        this.setDefaultModel();
    }
    
    setDefaultModel(){
        this.vendorInfo.DefaultModel = "";
        if (!this.vendorInfo.SpecificModelNeeded){
            if (this.vendorInfo.ModelGroupID > 0){
                this.vendorInfo.DefaultModel = this.modelGroupDropdownComponent.modelGroups.filter(x=>x.ID == this.vendorInfo.ModelGroupID)[0].Name;
            }
        }
    }
    
    setMaterialNumber(){
        this.vendorInfo.MaterialNumber = "";
        if (this.vendorInfo.ModelGroupID > 0){
            this.vendorInfo.MaterialNumber = this.modelDropdownComponent.models.filter(x=>x.ID == this.vendorInfo.ModelID)[0].MaterialNumber;
        }
    }

    setCONAModelNumber(){
        this.vendorInfo.CONAModelGroup = "";
        if (this.vendorInfo.ModelGroupID > 0){
            this.vendorInfo.CONAModelGroup = this.modelDropdownComponent.models.filter(x=>x.ID == this.vendorInfo.ModelID)[0].CONAModelGroup;
        }
    }

    showLevelSellDown(): boolean{
        return this.vendorInfo.ModelGroupID == enums.ModelGroupEnum.LargeGlassFront || this.vendorInfo.ModelGroupID == enums.ModelGroupEnum.SmallGlassFront;
    }

    onLineItemsChanged(event: number){
        this.vendorDetailsForm.controls['removeReason'].clearValidators();
        this.vendorDetailsForm.controls['installReason'].clearValidators();
        if (event > 0){
            if (this.showRemoveReason){
                this.vendorDetailsForm.controls['removeReason'].setValidators(Validators.required);
            }
            if (this.showInstallReason){
                this.vendorDetailsForm.controls['installReason'].setValidators(Validators.required);
            }
        }
        
        this.vendorDetailsForm.controls['removeReason'].updateValueAndValidity()
        this.vendorDetailsForm.controls['installReason'].updateValueAndValidity()
    }

    setBusinessType(businessTypeID: number) {
        
        if (businessTypeID == enums.BusinessTypeEnum.DSD) {
            this.equipmentLocationsComponent.setLineItemLimit(1);
        }
        else {
            this.equipmentLocationsComponent.setLineItemLimit(1000);
        }
        
    }

    setCustomerType(customerTypeID: number) {
        
        var limit = 1000;
        if (this.requestTypeID == enums.RequestTypeEnum.EquipmentInstall){
            if (customerTypeID == enums.CustomerTypeEnum.FullService) {
                limit = 1;
            }
        }
        this.equipmentLocationsComponent.setLineItemLimit(limit);
        
    }

}
